module.exports = __webpack_public_path__ + "img/1000091590.82915c5e.jpg";